var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn-toggle',{attrs:{"tile":"","group":"","mandatory":""},model:{value:(_vm.peopleSort),callback:function ($$v) {_vm.peopleSort=$$v},expression:"peopleSort"}},[_c('v-btn',{attrs:{"small":"","value":"firstName"}},[_vm._v(" Vorname ")]),_c('v-btn',{attrs:{"small":"","value":"lastName"}},[_vm._v(" Nachname ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }